export class DmsDownloadElementResource {
  sphereId?: number;
  userId?: number;
  fiscalYear: number;
  ids: number[] = [];
  conservation = false;
  dossier: boolean = false;
}
